import _ from 'lodash'
import { call, put, select } from 'redux-saga/effects'

import { updateSumAssured } from 'quick-quote/product-common/coverage-plan/actions'
import { getSumAssured$ } from 'quick-quote/product-common/coverage-plan/selectors'

/**
 * createProductLifeReadyHandler
 * @param productCommonService {ReturnType<import('./product-common').createProductCommonService>}
 */
export function createProductLifeReadyService(productCommonService) {
  function onSelectProduct(productGroup) {
    return function*(action) {
      const code = action.payload
      const comingDisplayProduct = productCommonService.getDisplayProductFromCache(code)
      if (comingDisplayProduct) {
        if (['CANCERX5', 'KOOMVER_COVER', 'KOOMVER_COMPENSATE'].includes(productGroup)) {
          const sumAssured$ = _.cloneDeep(yield select(getSumAssured$))
          sumAssured$.value = comingDisplayProduct.entrySumAssured.minimum
          yield put(updateSumAssured(sumAssured$))
        }

        yield call(productCommonService.onChangeProduct, comingDisplayProduct)
      }
    }
  }

  return {
    onSelectProduct,
  }
}
